<template>
  <div class="font-tip">
    <el-tooltip class="item" effect="dark" :content="tip" placement="bottom">
      <i class="iconfont icon-shuoming"></i>
    </el-tooltip>
  </div>
</template>

<script>
  export default {
    props: ['tip']
  };
</script>

<style lang="less">
.el-tooltip__popper {
  max-width: 360px;
  line-height: 1.6;
}
</style>



// WEBPACK FOOTER //
// FontTip.vue?2d9067fa